import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  CardTitle,
  Form,
  Label,
  Modal,
  ModalBody,
  Button,
} from "reactstrap"
import { withRouter } from "react-router"
import { ToastContainer, toast, Slide } from "react-toastify"
import DatePicker from "react-datepicker"
import Select from "react-select"
import apis from "../../api"

const DataTableEns = props => {
  const [loading, setLoading] = useState(false)
  const [orders, setOrders] = useState([])
  const [departement, setDepartement] = useState([])
  const [selectDepartement, setSelectDepartement] = useState("")
  const [annee, setAnnee] = useState("")
  const [imp, setImp] = useState(0)
  const [view, setView] = useState(0)
  const [add, setAdd] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [modal, setModal] = useState(false)
  const [modalCloture, setModalCloture] = useState(false)
  const [id, setId] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  var role_id = userAuthScolarite.user.role_id
  var email = userAuthScolarite.user.email

  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Emploi enseignant")
    )
    setImp(typeArticleSubMenu.sous_menu[0].imp)
    setView(typeArticleSubMenu.sous_menu[0].view)
    setAdd(typeArticleSubMenu.sous_menu[0].add)
    const resDepartement = await API.get("departement/select").then(
      resDepartement => {
        setDepartement(resDepartement.data.Departement)
        setSelectDepartement("")
      }
    )
    var userAuthScolarite = JSON.parse(
      localStorage.getItem("userAuthScolarite")
    )
    var annee_id = userAuthScolarite.user.annee_id
    setAnnee(annee_id)
    const res = await API.post("emploi/enseignant/list", {
      semestre_id: props.semestre,
      annee_id: annee_id,
    }).then(res => {
      setOrders(res.data.enseignants)
      setLoading(true)
    })
  }, [props.semestre])

  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    sizePerPage: 50,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }

  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "name",
      text: "Enseignant",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "cin",
      text: "CIN",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "grade",
      text: "Grade",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "Consultation",
      isDummyField: true,
      text: "Consultation",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        view === 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{
                color: row.emploi == 0 ? "cornflowerblue" : "green",
                cursor: "pointer",
              }}
              onClick={() =>
                props.history.push(
                  "/EmploiEnseignant?id=" + row.id + "/" + row.semestre
                )
              }
              className="fas fa-eye"
            ></i>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-eye"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Emploi",
      isDummyField: true,
      text: "Emploi",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          add === 1 ? (
            row.cloture === 0 ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i
                  style={{
                    color: row.emploi == 0 ? "cornflowerblue" : "green",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    props.history.push(
                      "/AddScheduleEnseignant?id=" + row.id + "/" + row.semestre
                    )
                  }
                  className="fas fa-calendar-alt"
                ></i>
              </div>
            ) : role_id === 1 && row.cloture === 1 ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i
                  style={{
                    color: row.emploi == 0 ? "cornflowerblue" : "green",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    props.history.push(
                      "/AddScheduleEnseignant?id=" + row.id + "/" + row.semestre
                    )
                  }
                  className="fas fa-calendar-alt"
                ></i>
              </div>
            ) : (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i
                  style={{ color: "#ea0b0b", cursor: "pointer" }}
                  className="fas fa-calendar-alt"
                  title={"Cet emploi est clôturé"}
                ></i>
              </div>
            )
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-calendar-alt"
                title={"Vous n'avez pas d'accès"}
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-calendar-alt"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    {
      dataField: "id",
      isDummyField: true,
      text: "Téléchargement",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        imp === 1 ? (
          <a
            href={
              "https://flshs.scolarite.backcresus-institut.ovh/api/impression_enseignant_shedules/" +
              row.id +
              "/" +
              row.semestre +
              "/" +
              annee
            }
            target="_blank"
            rel="noreferrer"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <i
              style={{ color: "#955cd5", cursor: "pointer" }}
              className="fas fa-file-download"
            ></i>
          </a>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-file-download"
            ></i>
          </div>
        ),
    },

    {
      dataField: "id",
      isDummyField: true,
      text: "Téléchargement sans CIN",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        imp === 1 ? (
          <a
            href={
              "https://flshs.scolarite.backcresus-institut.ovh/api/impression_enseignant_shedules_sans_cin/" +
              row.id +
              "/" +
              row.semestre +
              "/" +
              annee
            }
            target="_blank"
            rel="noreferrer"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <i
              style={{ color: "#955cd5", cursor: "pointer" }}
              className="fas fa-file-download"
            ></i>
          </a>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-file-download"
            ></i>
          </div>
        ),
    },
  ]

  const { SearchBar } = Search

  const search = async () => {
    if (selectDepartement.value != "" || selectDepartement.value != null) {
      setOrders([])
      const res = await API.post("emploi/enseignant/search", {
        semestre_id: props.semestre,
        departement_id: selectDepartement.value,
        annee_id,
      }).then(res => {
        setOrders(res.data.enseignants)
      })
    } else {
      toast.error("⛔ département est obligatroire !", {
        containerId: "A",
      })
    }
  }
  const searchAll = async () => {
    var userAuthScolarite = JSON.parse(
      localStorage.getItem("userAuthScolarite")
    )
    var annee_id = userAuthScolarite.user.annee_id
    const res = await API.post("emploi/enseignant/list", {
      semestre_id: props.semestre,
      annee_id: annee_id,
    }).then(res => {
      setOrders(res.data.enseignants)
      setLoading(true)
    })
  }
  const afficherAll = async () => {
    const res = await apis
      .post("emploi/affichage_emploi_enseignant", {
        annee_id: annee_id,
        user_id,
        afficher: 1,
        semestre_id: props.semestre,
      })
      .then(res => {
        API.post("emploi/enseignant/list", {
          annee_id,
          semestre_id: props.semestre,
        }).then(resA => {
          setModal(false)
          setOrders(resA.data.enseignants)
          setLoading(true)
        })
      })
  }
  const masquerAll = async () => {
    const res = await apis
      .post("emploi/affichage_emploi_enseignant", {
        annee_id: annee_id,
        user_id,
        afficher: 0,
        semestre_id: props.semestre,
      })
      .then(res => {
        if (res.data.errNum === 200 || res.data.errNum === "200") {
          API.post("emploi/enseignant/list", {
            annee_id,
            semestre_id: props.semestre,
          }).then(resA => {
            setModal(false)
            setOrders(resA.data.enseignants)
            setLoading(true)
            toast.success(res.data.msg, { containerId: "A" })
          })
        } else {
          toast.error(res.data.msg, { containerId: "A" })
        }
      })
  }
  const toggle = row => {
    setModal(true)
    setId(row.id)
  }
  const toggleCloture = row => {
    setModalCloture(true)
    setId(row.id)
  }
  const closeModal1 = () => {
    setModal(false)
  }
  const closeModal12 = () => {
    setModalCloture(false)
  }
  const cloturer = async () => {
    const res = await API.post("emploi/cloturerTout", {
      semestre_id: props.semestre,
      annee_id: annee_id,
      user_id,
      etat: 1,
    }).then(res => {
      setModalCloture(false)
    })
  }
  const Decloturer = async () => {
    const res = await API.post("emploi/cloturerTout", {
      semestre_id: props.semestre,
      annee_id: annee_id,
      user_id,
      etat: 0,
    }).then(res => {
      setModalCloture(false)

    })
  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row className="mt-4">
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <div>
                      <CardTitle style={{ color: "#556ee6" }} className="h4">
                        Critéres de Recherches
                      </CardTitle>
                      <Form className="mt-4">
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label for="basicpill-lastname-input2">
                                Département :
                              </Label>
                              <Select
                                options={departement}
                                isSearchable={true}
                                // isClearable={true}
                                value={selectDepartement}
                                onChange={e => setSelectDepartement(e)}
                              />
                            </div>
                          </Col>

                          <Col lg="6" style={{ padding: "26px 35px" }}>
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#761C19",
                                borderColor: "#761C19",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={search}
                            >
                              Rechercher
                            </button>
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#1f7619",
                                borderColor: "#1f7619",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={toggle}
                            >
                              Afficher / masquer emploi pour tous les
                              enseignants
                            </button>
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#761C19",
                                borderColor: "#761C19",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={searchAll}
                            >
                              Afficher tout
                            </button>
                          </Col>
                        </Row>
                      </Form>
                      {imp === 1 ? (
                        <Row style={{ textAlign: "center" }}>
                          <Col lg="3">
                            {selectDepartement.value ? (
                              <a
                                className="col-md-3"
                                href={
                                  "https://flshs.scolarite.backcresus-institut.ovh/api/impression_enseignants_departement_shedules" +
                                  "/" +
                                  selectDepartement.value +
                                  "/" +
                                  props.semestre +
                                  "/" +
                                  annee
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button className="btn btn-primary btn btn-primary">
                                  <i className="fas fa-file-download font-size-16 align-middle me-2"></i>
                                  Emplois enseignants par département
                                </button>
                              </a>
                            ) : (
                              <a
                                className="col-md-3"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button className="btn btn-primary btn btn-primary">
                                  <i className="fas fa-file-download font-size-16 align-middle me-2"></i>
                                  Emplois enseignants par département
                                </button>
                              </a>
                            )}
                          </Col>
                          <Col lg="3">
                            {selectDepartement.value ? (
                              <a
                                className="col-md-3"
                                href={
                                  "https://flshs.scolarite.backcresus-institut.ovh/api/impression_enseignants_departement_shedules_sans_cin" +
                                  "/" +
                                  selectDepartement.value +
                                  "/" +
                                  props.semestre +
                                  "/" +
                                  annee
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button className="btn btn-info btn btn-info">
                                  <i className="fas fa-file-download font-size-16 align-middle me-2"></i>
                                  Emplois enseignants par département sans CIN
                                </button>
                              </a>
                            ) : (
                              <a
                                className="col-md-3"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button className="btn btn-info btn btn-info">
                                  <i className="fas fa-file-download font-size-16 align-middle me-2"></i>
                                  Emplois enseignants par département sans CIN
                                </button>
                              </a>
                            )}
                          </Col>
                          <Col lg="2">
                            <a
                              className="col-md-3"
                              href={
                                "https://flshs.scolarite.backcresus-institut.ovh/api/impression_enseignants_shedules" +
                                "/" +
                                props.semestre +
                                "/" +
                                annee
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              <button className="btn btn-primary btn btn-primary">
                                <i className="fas fa-file-download font-size-16 align-middle me-2"></i>
                                Emplois enseignants
                              </button>
                            </a>
                          </Col>
                          <Col lg="2">
                            <a
                              className="col-md-3"
                              href={
                                "https://flshs.scolarite.backcresus-institut.ovh/api/impression_enseignants_shedules_sans_cin" +
                                "/" +
                                props.semestre +
                                "/" +
                                annee
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              <button className="btn btn-info btn btn-info">
                                <i className="fas fa-file-download font-size-16 align-middle me-2"></i>
                                Emplois enseignants sans CIN
                              </button>
                            </a>
                          </Col>
                          {(email == "gerant@cresus.pro" ||
                            email == "najiba.chkir@flshs.usf.tn") &&
                          (cloture !== 1 || cloture !== "1") ? (
                            <Col lg="2">
                              <Button
                                type="button"
                                style={{
                                  backgroundColor: "#bf399a",
                                  borderColor: "#bf399a",
                                }}
                                className="btn btn-success mb-2 me-2"
                                onClick={toggleCloture}
                              >
                                Clôturer / Déclôturer
                              </Button>
                            </Col>
                          ) : null}
                        </Row>
                      ) : null}
                      <div
                        className="mb-12 row"
                        style={{ display: "flex", marginTop: "15px" }}
                      >
                        <div className="col-md-6 mb-2 row">
                          <div className="col-md-12 search-box-etd">
                            <div
                              className="search-box me-2 mb-2 d-inline-block"
                              style={{ width: "100%" }}
                            >
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      rowStyle={(row, rowIndex) => {
                        if (row.valider === 1) {
                          return { backgroundColor: "#d9f6d6" } // vert clair
                        }
                        return {} // aucune couleur sinon
                      }}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              En cours ...
            </h4>
          </div>
        )}
      </div>
      <Modal isOpen={modal} toggle={closeModal1} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          // toggle={closeModal}
        >
          {"Afficher / masquer l'emploi du temps dans l'espace enseignant"}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {
                  "Êtes-Vous sûr d'afficher / masquer l'emploi du temps dans l'espace enseignant"
                }
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded"
                  onClick={afficherAll}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {"Afficher"}
                </Button>
              </div>
              <div>
                <Button
                  onClick={closeModal1}
                  color="warning"
                  className="btn-rounded "
                >
                  {"Annuler"}
                </Button>
              </div>
              <div>
                <Button
                  color="danger"
                  className="btn-rounded"
                  onClick={masquerAll}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Masquer"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalCloture} toggle={closeModal12} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          // toggle={closeModal}
        >
          {"Clôturer / Déclôturer l'emploi du temps dans l'espace enseignant"}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {
                  "Êtes-Vous sûr de clôturer / déclôturer l'emploi du temps dans l'espace enseignant"
                }
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button color="info" className="btn-rounded" onClick={cloturer}>
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {"Clôturer"}
                </Button>
              </div>
              <div>
                <Button
                  onClick={closeModal1}
                  color="warning"
                  className="btn-rounded "
                >
                  {"Annuler"}
                </Button>
              </div>
              <div>
                <Button
                  color="danger"
                  className="btn-rounded"
                  onClick={Decloturer}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Déclôturer"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withRouter(DataTableEns)
DataTableEns.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
  semestre: PropTypes.any,
}
